/**
 * @Author: Nemo
 * @Description: 规则注册中心 - 管理所有校验规则
 * @Date: 2025-05-07
 * @FilePath: /rhcn-checkout-web/src/plugins/validator/core/registry.js
 */

// 规则存储
const rules = new Map();

/**
 * 注册一个校验规则
 * @param {string} name 规则名称
 * @param {object} rule 规则配置对象
 * @param {function} rule.validate 校验函数
 * @param {function} rule.message 错误消息函数
 */
export function registerRule(name, rule) {
  if (typeof rule.validate !== 'function') {
    throw new Error('规则必须包含validate函数');
  }

  rules.set(name, rule);
  return true;
}

/**
 * 获取规则
 * @param {string} name 规则名称
 */
export function getRule(name) {
  if (!rules.has(name)) {
    throw new Error(`规则"${name}"不存在`);
  }

  return rules.get(name);
}

/**
 * 获取所有规则名称
 */
export function getAllRuleNames() {
  return Array.from(rules.keys());
}
